import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { RotateCcw, ArrowLeft, Loader2, FileText, Archive } from "lucide-react";
import { api } from "../lib/api";
import Tip from "../components/Tip";

export default function DocumentsTrash() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = async () => {
    setLoading(true);
    try {
      const r = await api.docsTrash();
      setItems(r.items || []);
    } catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const restore = async (id) => {
    try { await api.docsRestore(id); toast.success("Ripristinato"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
  };

  return (
    <div className="space-y-4" data-testid="docs-trash-page">
      <div className="flex items-center gap-2 flex-wrap">
        <Link to="/documenti" className="rounded-full border px-3 py-1.5 text-xs inline-flex items-center gap-1 hover:bg-black/5" data-testid="trash-back">
          <ArrowLeft size={12}/> Torna a documenti
        </Link>
      </div>
      <div>
        <div className="text-xs font-mono uppercase tracking-widest opacity-70">Centro Documenti</div>
        <h1 className="mt-1 font-display text-3xl sm:text-4xl font-semibold inline-flex items-center gap-2"><Archive size={26}/> Cestino</h1>
        <p className="mt-2 text-sm opacity-80">Documenti eliminati negli ultimi 30 giorni. Ripristinali prima della cancellazione definitiva.</p>
      </div>
      {loading ? (
        <div className="flex items-center gap-2 opacity-70"><Loader2 size={16} className="animate-spin"/> Caricamento…</div>
      ) : items.length === 0 ? (
        <div className="pxos-card p-8 text-center opacity-70" data-testid="trash-empty">
          <Archive size={30} className="mx-auto opacity-40"/>
          <div className="mt-2">Il cestino è vuoto.</div>
        </div>
      ) : (
        <ul className="space-y-2" data-testid="trash-list">
          {items.map((d) => (
            <li key={d.id} className="pxos-card p-3 flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg grid place-items-center bg-black/5 shrink-0"><FileText size={16}/></div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold truncate">{d.title || d.filename}</div>
                <div className="text-xs opacity-60 mt-0.5">
                  Eliminato: {d.deleted_at ? new Date(d.deleted_at).toLocaleString("it-IT") : "—"} · {d.category}
                </div>
              </div>
              <Tip label="Ripristina">
                <button onClick={() => restore(d.id)} className="rounded-full border px-3 py-1.5 text-xs inline-flex items-center gap-1 hover:bg-black/5" data-testid="trash-restore">
                  <RotateCcw size={12}/> Ripristina
                </button>
              </Tip>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
